import { IEventHandler } from "./eventHandler";

export interface ISaveEventHandler {
    id: string;
    userCode: string;
    approve: boolean;
    approveMessage: string;
    modifyDate: number;
}

export class SaveEventHandler implements ISaveEventHandler {
    id: string;
    userCode: string;
    approve: boolean;
    approveMessage: string;
    modifyDate: number;

    constructor();
    constructor(obj: IEventHandler);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.userCode = obj && obj.userCode || "";
        this.approve = obj && obj.approveDate > 0;
        this.approveMessage = obj && obj.approveMessage || "";
        this.modifyDate = obj && obj.modifyDate || 0;
    }
}